/* ============================================================
   Strive-To-Be Theme — theme.js
   Mobile nav + progressive enhancement
   ============================================================ */

(function () {
  'use strict';

  // ── Mobile nav ──────────────────────────────────────────────
  const toggle   = document.getElementById('mobile-nav-toggle');
  const nav      = document.getElementById('mobile-nav');
  const overlay  = document.getElementById('mobile-nav-overlay');
  const closeBtn = document.getElementById('mobile-nav-close');

  if (toggle && nav) {
    let lastFocused;
    const open = () => {
      lastFocused = document.activeElement;
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close navigation menu');
      document.body.style.overflow = 'hidden';
      closeBtn?.focus();
    };
    const close = () => {
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open navigation menu');
      document.body.style.overflow = '';
      lastFocused?.focus();
    };

    toggle.addEventListener('click', open);
    if (overlay)  overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', close));

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) close();
    });
  }

  // ── Active nav link ─────────────────────────────────────────
  const path = window.location.pathname;
  document.querySelectorAll('.site-header__nav-link').forEach((link) => {
    const href = link.getAttribute('href');
    if (href && href !== '/' && path.startsWith(href)) {
      link.style.color = 'var(--color-accent)';
      link.style.background = 'var(--color-surface)';
    }
  });

  // ── Smooth scroll for anchor CTAs ───────────────────────────
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (e) => {
      const id = anchor.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ── Revenue CTA and form analytics ───────────────────────
  const track = (eventName, details) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: eventName, ...details });
    if (typeof window.gtag === 'function') window.gtag('event', eventName, details);
    if (typeof window.fbq === 'function') window.fbq('trackCustom', eventName, details);
  };

  document.querySelectorAll('[data-cta]').forEach((element) => {
    element.addEventListener('click', () => track('stb_cta_click', { cta: element.dataset.cta }));
  });

  document.querySelectorAll('[data-project-type]').forEach((element) => {
    element.addEventListener('click', () => {
      const projectType = document.getElementById('ContactProjectType');
      if (projectType) projectType.value = element.dataset.projectType;
    });
  });

  const contactForm = document.getElementById('RevenueContactForm');
  if (contactForm) contactForm.addEventListener('submit', () => track('stb_contact_form_submit', { form: 'revenue-homepage' }));
  document.querySelector('.form-status')?.focus();

})();
